module.exports = __webpack_public_path__ + "static/bsas019.thumb-a0ff8eef878fef4bfff97472f69a0494.jpg";